import React from "react";
import { Phone, Mail } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_biz-hub-206/artifacts/n4vp97w9_logo%20size.png";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-brand-moss-deep text-brand-sand/80 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-12 grid grid-cols-1 sm:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid place-items-center w-12 h-12 rounded-full bg-white overflow-hidden">
              <img src={LOGO_URL} alt="Rafael Costa Garden Care logo" className="w-full h-full object-contain p-1" />
            </span>
            <div>
              <div className="font-display font-bold text-white text-base">Rafael Costa Garden Care</div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-brand-sand/60">Friendly gardeners</div>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            A small, family-run gardening team caring for local gardens with old-school dedication.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-white/80 mb-4">Quick links</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="hover:text-white transition-colors">Services</a></li>
            <li><a href="#about" className="hover:text-white transition-colors">About us</a></li>
            <li><a href="#gallery" className="hover:text-white transition-colors">Gallery</a></li>
            <li><a href="#testimonials" className="hover:text-white transition-colors">Reviews</a></li>
            <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-white/80 mb-4">Get in touch</div>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:07467946894" className="inline-flex items-center gap-2 hover:text-white">
                <Phone className="w-4 h-4" /> 07467 946894
              </a>
            </li>
            <li>
              <a href="mailto:rafagr2023@gmail.com" className="inline-flex items-center gap-2 hover:text-white break-all">
                <Mail className="w-4 h-4" /> rafagr2023@gmail.com
              </a>
            </li>
            <li>
              <a
                href="https://api.whatsapp.com/message/NWVD2NCMR723P1?autoload=1&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 hover:text-white"
              >
                <svg viewBox="0 0 32 32" className="w-4 h-4" fill="currentColor" aria-hidden="true">
                  <path d="M16 0a16 16 0 0 0-13.84 23.96L0 32l8.27-2.16A16 16 0 1 0 16 0Zm0 29.34c-2.34 0-4.6-.62-6.59-1.79l-.47-.28-4.9 1.28 1.31-4.78-.31-.49a13.34 13.34 0 1 1 10.96 6.06Z"/>
                </svg>
                Message on WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-14 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-brand-sand/60">
          <div>© {year} Rafael Costa Garden Care. All rights reserved.</div>
          <div>Made with care for local gardens.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
